import ApiError from "../../errors/ApiError";
import { UNLINK_CUSTOMER_KROSS_ERROR } from "./error-codes.constants";

export class UnlinkCustomerKrossError extends ApiError {
  constructor() {
    super(UNLINK_CUSTOMER_KROSS_ERROR);
  }
}
